import React from 'react';
import { bool, shape, string } from 'prop-types';

const Approved = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.24967 12.8334H10.4997C10.9838 12.8334 11.398 12.5417 11.573 12.1217L13.3347 8.00925C13.3872 7.87508 13.4163 7.73508 13.4163 7.58342V6.41675C13.4163 5.77508 12.8913 5.25008 12.2497 5.25008H8.56884L9.12301 2.58425L9.14051 2.39758C9.14051 2.15841 9.04134 1.93675 8.88384 1.77925L8.26551 1.16675L4.42134 5.01092C4.21134 5.22092 4.08301 5.51258 4.08301 5.83342V11.6667C4.08301 12.3084 4.60801 12.8334 5.24967 12.8334ZM5.24967 5.83351L7.78134 3.30184L6.99967 6.41684H12.2497V7.58351L10.4997 11.6668H5.24967V5.83351ZM2.91634 5.83342H0.583008V12.8334H2.91634V5.83342Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
  </svg>
);

Approved.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Approved;
